export default "__VITE_ASSET__eRGNJW_f__"